"use strict";

import React, {Component} from "react";
import {PropTypes, templates, tutils} from "Subschema";
const field = tutils.FREEZE_OBJ;
const {FieldSetTemplate, FormTemplate}=templates;
export default class FormTemplateExt extends Component {

    static displayName = 'FormTemplate';

    static propTypes = {
        ...FieldSetTemplate.propTypes,
        ...FormTemplate.propTypes,
        _csrf: PropTypes.value,
        _session: PropTypes.value,
		viewId: PropTypes.value,
        styleClass: PropTypes.style
    };

    static defaultProps = {
        field,
        method: "post",
        _csrf: "_csrf",
        _session: "_session",
		viewId: "_internal.viewId",
        styleClass: "FormTemplate"
    };

    render() {
        const {legend, content, template, children, _csrf, viewId, style, _session, legendClass, buttons, className, styleClass, formClass, ...rest} =this.props;
		const action = `/signup/${viewId}?force_consumersignup=1`;
        return (<form {...rest} action={action} autoComplete="off" className={formClass}>{legend ?
            <fieldset className={className}>
                <legend className={legendClass}>{legend}</legend>
                {content}
                {children}
                {buttons}
            </fieldset> :
            <div className={className}>
                {content}
                {children}
                {buttons}
            </div>}
            <input type="hidden" name="_csrf" value={_csrf}/>
            <input type="hidden" name="_session" value={_session}/>
            {typeof window === "undefined" && typeof document === "undefined" && <input type="hidden" name="nonJS" value="true" />}
        </form>);
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/FormTemplate.jsx
 **/